export const news = [
  {
    id: 1,
    title: "Bitcoin slides below $80,000",
    subtitle:
      "Bitcoin slides below $80,000, Ether falls to 16-month low near $1,800 amid broader market sell-offBitcoin slides below $80,000, Ether falls to 16-month low near $1,800 amid broader market sell-off",
    time: "9 hours ago",
  },
  {
    id: 2,
    title: "Bitcoin slides below $80,000",
    subtitle:
      "Bitcoin slides below $80,000, Ether falls to 16-month low near $1,800 amid broader market sell-offBitcoin slides below $80,000, Ether falls to 16-month low near $1,800 amid broader market sell-off",
    time: "9 hours ago",
  },
  {
    id: 3,
    title: "Bitcoin slides below $80,000",
    subtitle:
      "Bitcoin slides below $80,000, Ether falls to 16-month low near $1,800 amid broader market sell-offBitcoin slides below $80,000, Ether falls to 16-month low near $1,800 amid broader market sell-off",
    time: "9 hours ago",
  },
];
